<template>
  <Section
    @back="$emit('back')"
    title="対象オフィス設定"
    margin
    tip-message="対象オフィス設定に戻る"
  >
    <template>
      <v-subheader>業種分類</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidIndustryClassification" xs9>
          <v-layout
            v-for="target in industryClassificationTargetsStrs"
            :key="target.name"
          >
            {{ target.sectorName }} > {{ target.name }}
          </v-layout>
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>上場区分</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidListingCategoryClassification" xs9>
          {{ listingCategoryClassificationTargetStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>従業員数</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidEmployees" xs9>
          {{ employeesTargetStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>売上高規模</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidSalesAmount" xs9>
          {{ salesAmountTargetStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmArea :menuSetting="menuSetting" />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmArea from './CampaignModalPageConfirmArea'

export default {
  name: 'CampaignModalPageConfirmOfficeTarget',
  components: {
    Section,
    CampaignModalPageConfirmArea,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    industryClassificationTargetsStrs() {
      return this.menuSetting.industryClassificationTargets
        .map(target =>
          target.industryClassificationCodeAndNames.map(codeAndName => {
            return {
              sectorName: target.name,
              name: codeAndName.name,
            }
          }),
        )
        .flat()
    },
    listingCategoryClassificationTargetStr() {
      return this.menuSetting.listingCategoryClassificationTarget.listingCategoryClassificationTargetKeyAndNames
        .map(target => target.name)
        .join(', ')
    },
    employeesTargetStr() {
      const employeesTarget = this.menuSetting.employeesTarget
      return (
        this.getEmployeeCondition(employeesTarget.minEmployees) +
        '以上 ~ ' +
        this.getEmployeeCondition(employeesTarget.maxEmployees) +
        (employeesTarget.maxEmployees === null ? '' : '未満')
      )
    },
    salesAmountTargetStr() {
      const salesAmountTarget = this.menuSetting.salesAmountTarget
      return (
        this.getSalesAmountCondition(salesAmountTarget.minSalesAmount) +
        '以上 ~ ' +
        this.getSalesAmountCondition(salesAmountTarget.maxSalesAmount) +
        (salesAmountTarget.maxSalesAmount === null ? '' : '未満')
      )
    },
  },
  methods: {
    getEmployeeCondition(value) {
      if (value === null) {
        return '上限なし'
      }
      if (value === 10000) {
        return '1万人'
      }
      if (value >= 1000) {
        return value / 1000 + '千人'
      }
      return value + '人'
    },
    getSalesAmountCondition(value) {
      if (value === null) {
        return '上限なし'
      }
      if (value === 0) {
        return '0円'
      }
      if (value === 50000000) {
        return '5千万円'
      }
      if (value === 1000000000000) {
        return '1兆円'
      }
      return value / 100000000 + '億円'
    },
  },
}
</script>
